import { LoadState } from "../../constants/enums";
import { IDisposition, IDispositionState } from "./disposition.types";

export const initialDisposition: IDisposition = {
  disposition_uuid: null,
  disposition: "",
  remark: "",
  status: "ACTIVE",
  type: "DISPOSITION",
  company_outlet_uuid: "",
};

export const initialDispositionState: IDispositionState = {
  disposition: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
};
